import React, { useState } from "react";
import { Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import CongratsPopUp from "../../Common/CongratsPopUp/CongratsPopUp";
import useModalWindowControls from "../../Hooks/useModal";
import { subscribeNewsletterApi } from "../../Service/blog";
import { STAYINLOOP } from "../../Routes/RouteConstent";
import "./BlogStayInLoopCTA.scss";

type BlogStayInLoopCTAProps = {
  /** `teaser` = copy + Subscribe button (blog list). `form` = email field (blog detail). */
  variant?: "teaser" | "form";
};

const BlogStayInLoopCTA = ({ variant = "form" }: BlogStayInLoopCTAProps) => {
  const [email, setEmail] = useState("");
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");
  const successModal = useModalWindowControls();
  const showForm = variant === "form";

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
    const trimmed = email.trim();
    if (!trimmed) {
      setError("Please enter your e-mail.");
      return;
    }

    setPending(true);
    try {
      const res: any = await subscribeNewsletterApi(trimmed);
      if (res?.data?.success) {
        setEmail("");
        successModal.openModal();
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setPending(false);
    }
  };

  return (
    <>
      {showForm ? (
        <CongratsPopUp closeModal={successModal.closeModal} isVisible={successModal.isVisible}>
          <h3>Thank you!</h3>
          <p>You have successfully subscribed to our newsletter.</p>
        </CongratsPopUp>
      ) : null}

      <Row className="py-4 blog-stay-loop-section">
        <div className="col-lg-12 col-md-12">
          <Container className="blog-stay-loop-inner">
            <div className="blog-stay-loop-panel w-100 py-4 py-md-5 px-3 px-md-5 mb-5">
              <div className="blog-stay-loop-caption d-flex justify-content-center align-items-center flex-column mx-auto">
                <h2>Subscribe to our Newsletter</h2>
                <p className="blog-stay-loop-copy mb-0">
                  Receive curated tips by parenting stage, topic, and location. Be the first to know
                  about new podcast releases, events, &amp; workshops!
                </p>

                {showForm ? (
                  <>
                    <form
                      className="blog-newsletter-form"
                      onSubmit={handleSubmit}
                      noValidate
                    >
                      <input
                        type="email"
                        name="email"
                        className="blog-newsletter-input"
                        placeholder="Enter your e-mail"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={pending}
                        required
                        autoComplete="email"
                        aria-label="Enter your e-mail"
                      />
                      <button type="submit" className="btn blog-newsletter-btn" disabled={pending}>
                        {pending ? <CircularProgress size={20} color="inherit" /> : "Subscribe"}
                      </button>
                    </form>
                    {error ? (
                      <p className="blog-newsletter-error mb-0" role="alert">
                        {error}
                      </p>
                    ) : null}
                  </>
                ) : (
                  <Link to={STAYINLOOP} className="btn blog-newsletter-btn blog-newsletter-btn--cta">
                    Stay in the loop
                  </Link>
                )}
              </div>
            </div>
          </Container>
        </div>
      </Row>
    </>
  );
};

export default BlogStayInLoopCTA;
